var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"device-main"},[_c('div',{staticClass:"warp"},[_c('my-header')],1),_c('div',{staticClass:"container"},[_c('keep-alive',[_c('router-view')],1)],1),_c('my-tool-box')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }